var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section", staticStyle: { padding: "20px 20px 10px 20px" } },
    [
      _c("span", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("Partners.formatInformation")))
      ]),
      _c(
        "div",
        { staticClass: "inner-row" },
        [
          _c(
            "el-form",
            {
              staticClass: "form-item-350",
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "100px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "margin-Right50",
                  attrs: { label: _vm.$t("SeaExport.codeAbbreviation") }
                },
                [
                  _c("cargo-input", {
                    attrs: {
                      no: "shortCode",
                      "auto-uppercase": _vm.notUppercaseShipperConsigneNotify
                    },
                    model: {
                      value: _vm.form.shortCode,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "shortCode", $$v)
                      },
                      expression: "form.shortCode"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.enterpriseCode") } },
                [
                  _c("cargo-input", {
                    attrs: {
                      no: "enterpriseCode",
                      "auto-uppercase": _vm.notUppercaseShipperConsigneNotify
                    },
                    model: {
                      value: _vm.form.enterpriseCode,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "enterpriseCode", $$v)
                      },
                      expression: "form.enterpriseCode"
                    }
                  })
                ],
                1
              ),
              _c("br"),
              _c(
                "el-form-item",
                {
                  staticClass: "margin-Right50",
                  attrs: { label: _vm.$t("Tool.Name") }
                },
                [
                  _c("cargo-input", {
                    attrs: {
                      no: "enterpriseName",
                      "auto-uppercase": _vm.notUppercaseShipperConsigneNotify
                    },
                    model: {
                      value: _vm.form.enterpriseName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "enterpriseName", $$v)
                      },
                      expression: "form.enterpriseName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    label: _vm.$t("Partners.detailAddress")
                  }
                },
                [
                  _c("cargo-input", {
                    attrs: {
                      no: "address",
                      "auto-uppercase": _vm.notUppercaseShipperConsigneNotify
                    },
                    model: {
                      value: _vm.form.address,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "address", $$v)
                      },
                      expression: "form.address"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "inner-row" },
        [
          _c(
            "el-form",
            {
              staticClass: "form-item-350",
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "100px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "form-item-450 margin-Right50",
                  attrs: { "label-width": "0" }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "90px" },
                          attrs: { no: "contactsType" },
                          model: {
                            value: _vm.form.contactsType,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "contactsType", $$v)
                            },
                            expression: "form.contactsType"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: _vm.$t("Partners.phone"), value: 0 }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("Partners.emailAddress"),
                              value: 1
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("Partners.relexNumber"),
                              value: 2
                            }
                          })
                        ],
                        1
                      ),
                      _c("cargo-input", {
                        staticStyle: { width: "350px", "margin-left": "10px" },
                        attrs: {
                          no: "contacts",
                          "auto-uppercase":
                            _vm.notUppercaseShipperConsigneNotify
                        },
                        model: {
                          value: _vm.form.contacts,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "contacts", $$v)
                          },
                          expression: "form.contacts"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.cityName") } },
                [
                  _c("cargo-input", {
                    attrs: {
                      no: "cityName",
                      "auto-uppercase": _vm.notUppercaseShipperConsigneNotify
                    },
                    model: {
                      value: _vm.form.cityName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "cityName", $$v)
                      },
                      expression: "form.cityName"
                    }
                  })
                ],
                1
              ),
              _c("br"),
              _c(
                "el-form-item",
                {
                  staticClass: "margin-Right50",
                  attrs: { label: _vm.$t("SeaExport.provinceCode") }
                },
                [
                  _c("cargo-input", {
                    attrs: {
                      no: "provinceCode",
                      "auto-uppercase": _vm.notUppercaseShipperConsigneNotify
                    },
                    model: {
                      value: _vm.form.provinceCode,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "provinceCode", $$v)
                      },
                      expression: "form.provinceCode"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.provinceName") } },
                [
                  _c("cargo-input", {
                    attrs: {
                      no: "provinceName",
                      "auto-uppercase": _vm.notUppercaseShipperConsigneNotify
                    },
                    model: {
                      value: _vm.form.provinceName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "provinceName", $$v)
                      },
                      expression: "form.provinceName"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "inner-row" },
        [
          _c(
            "el-form",
            {
              staticClass: "form-item-350",
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "100px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "margin-Right50",
                  attrs: { label: _vm.$t("SeaExport.ZipCode") }
                },
                [
                  _c("cargo-input", {
                    attrs: {
                      no: "zipCode",
                      "auto-uppercase": _vm.notUppercaseShipperConsigneNotify
                    },
                    model: {
                      value: _vm.form.zipCode,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "zipCode", $$v)
                      },
                      expression: "form.zipCode"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.countryCode") } },
                [
                  _c("cargo-input", {
                    attrs: {
                      no: "countryCode",
                      "auto-uppercase": _vm.notUppercaseShipperConsigneNotify
                    },
                    model: {
                      value: _vm.form.countryCode,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "countryCode", $$v)
                      },
                      expression: "form.countryCode"
                    }
                  })
                ],
                1
              ),
              _c("br"),
              _c(
                "el-form-item",
                {
                  staticClass: "margin-Right50",
                  attrs: { label: _vm.$t("SeaExport.aeoEnterpriseCode") }
                },
                [
                  _c("cargo-input", {
                    attrs: {
                      no: "aeoEnterpriseCode",
                      "auto-uppercase": _vm.notUppercaseShipperConsigneNotify
                    },
                    model: {
                      value: _vm.form.aeoEnterpriseCode,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "aeoEnterpriseCode", $$v)
                      },
                      expression: "form.aeoEnterpriseCode"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.specificContactName") } },
                [
                  _c("cargo-input", {
                    attrs: {
                      no: "specificContactsName",
                      "auto-uppercase": _vm.notUppercaseShipperConsigneNotify
                    },
                    model: {
                      value: _vm.form.specificContactsName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "specificContactsName", $$v)
                      },
                      expression: "form.specificContactsName"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "inner-row", staticStyle: { "padding-top": "0px" } },
        [
          _c(
            "el-form",
            {
              staticClass: "form-item-450",
              attrs: { disabled: _vm.readonly, inline: true }
            },
            [
              _c("el-form-item", [
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "200px" },
                        attrs: { no: "specificContactsType" },
                        model: {
                          value: _vm.form.specificContactsType,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "specificContactsType", $$v)
                          },
                          expression: "form.specificContactsType"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: {
                            label: _vm.$t("SeaExport.specificContactPhone"),
                            value: 0
                          }
                        }),
                        _c("el-option", {
                          attrs: {
                            label: _vm.$t(
                              "Partners.specificContactEmailAddress"
                            ),
                            value: 1
                          }
                        }),
                        _c("el-option", {
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.specificContactRelexNumber"
                            ),
                            value: 2
                          }
                        })
                      ],
                      1
                    ),
                    _c("cargo-input", {
                      staticStyle: { "margin-left": "10px" },
                      attrs: {
                        no: "specificContacts",
                        "auto-uppercase": _vm.notUppercaseShipperConsigneNotify
                      },
                      model: {
                        value: _vm.form.specificContacts,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "specificContacts", $$v)
                        },
                        expression: "form.specificContacts"
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: {
            width: "950px",
            "margin-top": "20px",
            "margin-bottom": "10px"
          }
        },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("Partners.notFormatInformation")))
          ]),
          _c(
            "el-button",
            {
              staticStyle: { float: "right" },
              attrs: {
                no: "formatSynchronize",
                disabled: _vm.readonly,
                type: "primary"
              },
              on: { click: _vm.syncformatToNotFormat }
            },
            [_vm._v(_vm._s(_vm.$t("Partners.formatSynchronize")))]
          )
        ],
        1
      ),
      _c(
        "el-form",
        { staticClass: "form-item-450", attrs: { disabled: _vm.readonly } },
        _vm._l(7, function(count) {
          return _c(
            "el-form-item",
            { key: "addressLine" + count },
            [
              _c("cargo-input", {
                ref: "addressLine" + count,
                refInFor: true,
                staticStyle: { width: "450px" },
                attrs: {
                  no: "addressLine" + count,
                  "filter-chars": false,
                  "auto-uppercase": _vm.notUppercaseShipperConsigneNotify
                },
                on: {
                  change: function() {
                    return _vm.wrapAddr(
                      _vm.form,
                      "addressLine" + count,
                      count + 1 > 7 ? null : "addressLine" + (count + 1),
                      _vm.maxChars
                    )
                  }
                },
                nativeOn: {
                  dblclick: function($event) {
                    return _vm.showAddressDialog($event)
                  }
                },
                model: {
                  value: _vm.form["addressLine" + count],
                  callback: function($$v) {
                    _vm.$set(_vm.form, "addressLine" + count, $$v)
                  },
                  expression: "form['addressLine'+count]"
                }
              })
            ],
            1
          )
        }),
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "320px" },
            attrs: {
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "auto-uppercase": _vm.advanceTextDialog.isUppercase,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              disabled: _vm.readonly
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.readonly,
                      expression: "!readonly"
                    }
                  ],
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "close" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }